import React from 'react';
import { FaShoppingBag, FaClock, FaSpinner, FaTruck } from 'react-icons/fa';
import { OrderSummary } from '../../types/order';

interface UserOrdersSummaryProps {
  ordersSummary: OrderSummary[];
  stats: {
    total_orders: number;
    pending_orders: number;
    preparing_orders: number;
    on_the_way_orders: number;
    completed_orders: number;
    total_spent: number;
  };
  loading?: boolean;
  onViewAllOrders: () => void;
}

const UserOrdersSummary: React.FC<UserOrdersSummaryProps> = ({
  ordersSummary,
  stats,
  loading = false,
  onViewAllOrders,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <FaShoppingBag className="text-green-600" />
          <h3 className="text-lg font-semibold text-gray-800">Siparişlerim</h3>
        </div>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded mb-3"></div>
          <div className="h-4 bg-gray-200 rounded mb-3"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-lg shadow-md p-4 cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onViewAllOrders}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FaShoppingBag className="text-green-600 text-lg" />
          <div>
            <h3 className="font-semibold text-gray-800">Siparişlerim</h3>
            <p className="text-sm text-gray-600">
              {stats.pending_orders > 0 ? (
                <span className="text-yellow-600">{stats.pending_orders} bekleyen sipariş</span>
              ) : stats.preparing_orders > 0 ? (
                <span className="text-blue-600">{stats.preparing_orders} hazırlanıyor</span>
              ) : stats.on_the_way_orders > 0 ? (
                <span className="text-purple-600">{stats.on_the_way_orders} yolda</span>
              ) : stats.total_orders > 0 ? (
                <span className="text-green-600">Tüm siparişler tamamlandı</span>
              ) : (
                <span className="text-gray-500">Henüz sipariş yok</span>
              )}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {stats.pending_orders > 0 && (
            <div className="flex items-center gap-1 text-yellow-600">
              <FaClock className="text-sm" />
              <span className="text-sm font-medium">{stats.pending_orders}</span>
            </div>
          )}

          {stats.preparing_orders > 0 && (
            <div className="flex items-center gap-1 text-blue-600">
              <FaSpinner className="text-sm animate-spin" />
              <span className="text-sm font-medium">{stats.preparing_orders}</span>
            </div>
          )}

          {stats.on_the_way_orders > 0 && (
            <div className="flex items-center gap-1 text-purple-600">
              <FaTruck className="text-sm" />
              <span className="text-sm font-medium">{stats.on_the_way_orders}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserOrdersSummary;
